module.exports = __webpack_public_path__ + "img/1.83e6b26a.png";